import React from "react";

// Employee codes arrive as "00123", "123" or 123 depending on the endpoint —
// compare them the same way the server normalizes them.
const normalizeCode = (value) => {
  const s = String(value ?? "").trim();
  return /^\d+$/.test(s) ? s.replace(/^0+(?=\d)/, "") : s;
};

/**
 * Is the signed-in employee part of this list? Lists are scoped by view: the
 * dashboard's manager scope leaves the manager out, while the Employees
 * page's hierarchy starts AT the manager and the admin list has everyone.
 */
export const isSelfInList = (list, selfCode, getCode = (e) => e?.id ?? e?.infinityCode) => {
  const code = normalizeCode(selfCode);
  if (!code || !Array.isArray(list)) return false;
  return list.some((item) => normalizeCode(getCode(item)) === code);
};

/**
 * A stat-card number rendered as "others + you", the same everywhere.
 *
 * `included` says whether the viewer is already inside `count`:
 *   - included  -> shows count − 1, then "+ you"   (no double count)
 *   - excluded  -> shows count as-is, then "+ you"
 * Renders the bare number when `show` is false (viewer isn't an employee, or
 * the card doesn't apply to them), so it can wrap every value unconditionally.
 */
const CountWithSelf = ({ count, show, included = false }) => {
  if (!show) return <>{count}</>;

  const n = Number(count);
  const others = included && Number.isFinite(n) ? Math.max(n - 1, 0) : count;

  return <>{others}</>;
};

export default CountWithSelf;
